import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import CategoryCards from './components/CategoryCards';
import FeaturedArticles from './components/FeaturedArticles';
import FAQ from './components/FAQ';
import CTABanner from './components/CTABanner';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '安全指南',
  url: 'https://yourdomain.com/',
  description: '全面客观的成人网站安全访问信息指引，涵盖合规平台识别、隐私保护、安全访问技巧及法律风险提示',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://yourdomain.com/category/{search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  publisher: {
    '@type': 'Organization',
    name: '安全指南',
    url: 'https://yourdomain.com/',
    description: '专注于网络安全与合规知识的教育平台',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '安全指南',
  url: 'https://yourdomain.com/',
  description: '专注于网络安全与合规知识的教育平台，帮助成年用户建立科学的网络使用观念',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@safety-guide.example.com',
    contactType: 'customer service',
    availableLanguage: '中文',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryCards />
        <FeaturedArticles />
        <FAQ />
        <CTABanner />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}